import styles from './GroupMarker.module.css'

interface GroupMarkerProps {
  count: number
}

export function GroupMarker({ count }: GroupMarkerProps) {
  return (
    <div className={styles.cluster}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle className={styles.circle} cx="18" cy="18" r="18" />
      </svg>
      <span className={styles.label}>{count}</span>
    </div>
  )
}
